// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.hidden{\n  display: none!important;\n  z-index: -1!important;\n  width: 0;\n  height: 0;\n  overflow: hidden;\n}\n.el-select{\n  padding-right: 20px;\n}\n.el-select__tags{\n  flex-wrap: nowrap;\n}\n.el-select .el-icon-close{\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
